import _toArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _classCallCheck from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _toConsumableArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { identity } from '@antv/util';
import { Base } from './base';
import { createInterpolateNumber, createInterpolateRound, createClamp, createNormalize, bisect, compose, d3LinearNice, isValid } from '../utils';
/** 当 domain 和 range 只有一段的时候的 map 的 工厂函数 */

var createBiMap = function createBiMap(domain, range, createInterpolate) {
  var _domain = _slicedToArray(domain, 2),
      d0 = _domain[0],
      d1 = _domain[1];

  var _range = _slicedToArray(range, 2),
      r0 = _range[0],
      r1 = _range[1];

  var normalize;
  var interpolate;

  if (d0 < d1) {
    normalize = createNormalize(d0, d1);
    interpolate = createInterpolate(r0, r1);
  } else {
    normalize = createNormalize(d1, d0);
    interpolate = createInterpolate(r1, r0);
  }

  return compose(interpolate, normalize);
};
/** 当 domain 和 range 有多段时候的 map 的 工厂函数 */


var createPolyMap = function createPolyMap(domain, range, createInterpolate) {
  var len = Math.min(domain.length, range.length) - 1;
  var normalizeList = new Array(len);
  var interpolateList = new Array(len);
  var reverse = domain[0] > domain[len];
  var ascendingDomain = reverse ? _toConsumableArray(domain).reverse() : domain;
  var ascendingRange = reverse ? _toConsumableArray(range).reverse() : range; // 每一段都生成 normalize 和 interpolate

  for (var i = 0; i < len; i += 1) {
    normalizeList[i] = createNormalize(ascendingDomain[i], ascendingDomain[i + 1]);
    interpolateList[i] = createInterpolate(ascendingRange[i], ascendingRange[i + 1]);
  } // 二分最右查找到相应的 normalize 和 interpolate


  return function (x) {
    var i = bisect(domain, x, 1, len) - 1;
    var normalize = normalizeList[i];
    var interpolate = interpolateList[i];
    return compose(interpolate, normalize)(x);
  };
};
/** 选择一个分段映射的函数 */


var choosePiecewise = function choosePiecewise(domain, range, interpolate, shouldRound) {
  var n = Math.min(domain.length, range.length);
  var createPiecewise = n > 2 ? createPolyMap : createBiMap;
  var createInterpolate = shouldRound ? createInterpolateRound : interpolate;
  return createPiecewise(domain, range, createInterpolate);
};
/**
 * Continuous 比例尺 的输入 x 和输出 y 满足：y = a * f(x) + b
 * 通过函数柯里化和复合函数可以在映射过程中去掉分支，提高性能。
 * 参考：https://github.com/d3/d3-scale/blob/master/src/continuous.js
 */


export var Continuous = /*#__PURE__*/function (_Base) {
  _inherits(Continuous, _Base);

  var _super = _createSuper(Continuous);

  function Continuous() {
    _classCallCheck(this, Continuous);

    return _super.apply(this, arguments);
  }

  _createClass(Continuous, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0, 1],
        nice: false,
        clamp: false,
        round: false,
        interpolate: createInterpolateNumber,
        tickCount: 5
      };
    }
    /**
     * y = interpolate(normalize(clamp(transform(x))))
     */

  }, {
    key: "map",
    value: function map(x) {
      if (!isValid(x)) return this.options.unknown;
      return this.output(x);
    }
    /**
     * x = transform(clamp(interpolate(normalize(y))))
     */

  }, {
    key: "invert",
    value: function invert(x) {
      if (!isValid(x)) return this.options.unknown;
      return this.input(x);
    }
  }, {
    key: "nice",
    value: function nice() {
      if (!this.options.nice) return;

      var _this$getTickMethodOp = this.getTickMethodOptions(),
          _this$getTickMethodOp2 = _toArray(_this$getTickMethodOp),
          min = _this$getTickMethodOp2[0],
          max = _this$getTickMethodOp2[1],
          tickCount = _this$getTickMethodOp2[2],
          rest = _this$getTickMethodOp2.slice(3);

      this.options.domain = this.chooseNice().apply(void 0, [min, max, tickCount].concat(_toConsumableArray(rest)));
    }
  }, {
    key: "getTicks",
    value: function getTicks() {
      var tickMethod = this.options.tickMethod;

      var _this$getTickMethodOp3 = this.getTickMethodOptions(),
          _this$getTickMethodOp4 = _toArray(_this$getTickMethodOp3),
          min = _this$getTickMethodOp4[0],
          max = _this$getTickMethodOp4[1],
          tickCount = _this$getTickMethodOp4[2],
          rest = _this$getTickMethodOp4.slice(3);

      return tickMethod.apply(void 0, [min, max, tickCount].concat(_toConsumableArray(rest)));
    }
  }, {
    key: "getTickMethodOptions",
    value: function getTickMethodOptions() {
      var _this$options = this.options,
          domain = _this$options.domain,
          tickCount = _this$options.tickCount;
      var min = domain[0];
      var max = domain[domain.length - 1];
      return [min, max, tickCount];
    }
  }, {
    key: "chooseNice",
    value: function chooseNice() {
      return d3LinearNice;
    }
  }, {
    key: "rescale",
    value: function rescale() {
      this.nice();

      var _this$chooseTransform = this.chooseTransforms(),
          _this$chooseTransform2 = _slicedToArray(_this$chooseTransform, 2),
          transform = _this$chooseTransform2[0],
          untransform = _this$chooseTransform2[1];

      this.composeOutput(transform, this.chooseClamp(transform));
      this.composeInput(transform, untransform, this.chooseClamp(untransform));
    }
  }, {
    key: "chooseClamp",
    value: function chooseClamp(transform) {
      var _this$options2 = this.options,
          shouldClamp = _this$options2.clamp,
          range = _this$options2.range;
      var domain = this.options.domain.map(transform);
      var n = Math.min(domain.length, range.length);
      return shouldClamp ? createClamp(domain[0], domain[n - 1]) : identity;
    }
  }, {
    key: "composeOutput",
    value: function composeOutput(transform, clamp) {
      var _this$options3 = this.options,
          domain = _this$options3.domain,
          range = _this$options3.range,
          round = _this$options3.round,
          interpolate = _this$options3.interpolate;
      var piecewise = choosePiecewise(domain.map(transform), range, interpolate, round);
      this.output = compose(piecewise, clamp, transform);
    }
  }, {
    key: "composeInput",
    value: function composeInput(transform, untransform, clamp) {
      var _this$options4 = this.options,
          domain = _this$options4.domain,
          range = _this$options4.range;
      var piecewise = choosePiecewise(range, domain.map(transform), createInterpolateNumber);
      this.input = compose(untransform, clamp, piecewise);
    }
  }]);

  return Continuous;
}(Base);